import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import SmsSettingsPanel from '../../../components/siteadmin/ConfigSettingsForm/SmsSettingsPanel';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, intl }) {
  if (!store.getState().runtime.isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }
  const title = intl.formatMessage(messages.smsSettings);
  return {
    title,
    component: <AdminLayout>
      <div>
        <h1>{title}</h1>
        <SmsSettingsPanel />
      </div>
    </AdminLayout>,
  };
}
